import { ReactNode, useEffect, useState } from 'react';
import { Spin } from 'antd';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { getCurrentLanguage } from '../../Helpers/RouteHelper';
import { PublicSiteService } from '../../Services/PublicSiteService';

type PublicSiteMemberAuthGuardProps = {
    children: ReactNode;
};

export const PublicSiteMemberAuthGuard = ({ children }: PublicSiteMemberAuthGuardProps) => {
    const params = useParams();
    const location = useLocation();
    const [checkingAuth, setCheckingAuth] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const validateAuth = async () => {
            try {
                await PublicSiteService.GetMember();
                if (isMounted) {
                    setIsAuthenticated(true);
                }
            } catch {
                if (isMounted) {
                    setIsAuthenticated(false);
                }
            } finally {
                if (isMounted) {
                    setCheckingAuth(false);
                }
            }
        };

        validateAuth();

        return () => {
            isMounted = false;
        };
    }, [params.companyurl]);

    if (checkingAuth) {
        return (
            <div style={{ textAlign: 'center', padding: '100px' }}>
                <Spin size='large' />
            </div>
        );
    }

    if (!isAuthenticated) {
        const language = getCurrentLanguage();
        const companyUrl = params.companyurl;

        if (!companyUrl) {
            return <Navigate to={`/${language}/`} replace />;
        }

        return (
            <Navigate
                to={`/${language}/${companyUrl}/login`}
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }

    return <>{children}</>;
};
